import styled, { css } from 'styled-components';
import media from 'styled-media-query';
const ModalModifiers = {
    open: (theme, disableBackground) => css `
    position: fixed;
    top: 0;
    left: 0;
    min-width: 100%;
    height: 100%;
    background: ${disableBackground ? 'none' : `${theme.color.modal.nth1}`};
    padding: ${theme.spacing.stack.xxs};
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
  `,
    closed: () => css `
    display: none;
  `
};
export const Modal = styled.div `
  ${({ open, disableBackground, theme }) => css `
    ${open
    ? ModalModifiers.open(theme, disableBackground)
    : ModalModifiers.closed}
  `}
`;
const CardModifiers = {
    error: (theme) => css `
    .box-container {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      column-gap: ${theme.spacing.inline.small};
    }
    .icon-text {
      display: flex;
      flex-direction: row;
      margin-bottom: ${theme.spacing.inline.xxxs};
    }
    .icon-box {
      margin-right: ${theme.spacing.inline.xxxs};
    }
    .text-container {
      width: 100%;
    }
  `,
    errorWithoutDescription: (theme) => css `
    .box-container {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }
    .icon-text {
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-bottom: ${theme.spacing.inline.xxxs};
    }
    .text-container {
      width: 100%;
      > p {
        text-align: center;
      }
    }
  `,
    success: (theme) => css `
    .box-container {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      column-gap: ${theme.spacing.inline.small};
    }
    .icon-text {
      display: flex;
      align-items: center;
      text-align: left;
    }
    .text-container {
      margin: 0 ${theme.spacing.inline.xxxs};
    }
    .button-container {
      height: 100%;
      align-self: flex-end;
    }
  `
};
export const Card = styled.div `
  ${({ theme, variant, description }) => css `
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    margin-top: auto;
    width: 100%;
    .button-container {
      display: flex;
      .cancelButton {
        margin-right: ${theme.spacing.inline.nano};
      }
    }
    padding: ${variant === 'error'
    ? theme.spacing.inline.xxxs
    : `${theme.spacing.inline.xxs} ${theme.spacing.inline.xxxs}`};
    background: #f3eef3;
    border-radius: ${theme.spacing.inline.small}; 
    ${variant === 'error'
    ? description
        ? CardModifiers.error(theme)
        : CardModifiers.errorWithoutDescription(theme)
    : CardModifiers.success(theme)}
    ${media.greaterThan('medium') `
        ${css `
          margin-top: 0;
          align-self: center;
          max-width: 346px;
        `}
    `}
  `}
`;
export const Message = styled.p `
  ${({ theme }) => css `
    font-size: ${theme.font.size.sm};
    font-weight: ${theme.font.weight.bold};
    color: ${theme.color.base.nth1};
  `}
`;
export const Description = styled.p `
  ${({ theme }) => css `
    font-size: ${theme.font.size.sm};
    font-weight: ${theme.font.weight.regular};
    text-align: left;
    color: ${theme.color.base.nth1};
  `}
`;
export const Icon = styled.div `
  ${({ theme, variant }) => css `
    font-size: ${theme.font.size.md};
    color: ${variant === 'error'
    ? theme.color.alert.warning.nth1
    : theme.color.alert.success.nth3};
  `}
`;
//# sourceMappingURL=AlertModal.styles.js.map